export default {
  CUSTOMIZATION_DRAFT_SAVED: 'Customization draft saved',
  CUSTOMIZATION_DRAFT_PUBLISHED: 'Customization draft published'
};
